<template>
  <div class="daily-time">
    <div class="daily-time__legend">
      <span class="daily-time__legend-item">
        <i class="daily-time__bar is-selected" />已选
      </span>
      <span class="daily-time__legend-item">
        <i class="daily-time__bar" />未选
      </span>
    </div>
    <div class="daily-time__axis">
      <div
        v-for="half in halves"
        :key="half.title"
        class="daily-time__half"
      >
        <div class="daily-time__range">{{ half.title }}</div>
        <div class="daily-time__hours">
          <span
            v-for="hour in half.hours"
            :key="hour"
          >{{ hour }}</span>
        </div>
        <div class="daily-time__cells">
          <div
            v-for="offset in 24"
            :key="half.start + offset - 1"
            class="daily-time__cell"
            :class="getCellClass(half.start + offset - 1)"
            @mousedown.prevent="handleMouseDown(half.start + offset - 1)"
            @mouseenter="handleMouseEnter(half.start + offset - 1)"
          />
        </div>
      </div>
    </div>
    <div class="daily-time__footer">
      <div class="daily-time__footer-top">
        <span>已选时间段</span>
        <span
          class="daily-time__clear"
          @click="clearAll"
        >清空</span>
      </div>
      <div class="daily-time__ranges">{{ rangeText }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DailyTimeBar',
  data() {
    return {
      selected: Array.from({ length: 48 }, () => false),
      isMouseDown: false,
      dragStart: null,
      dragEnd: null,
      halves: [
        { title: '00:00 - 12:00', start: 0, hours: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] },
        { title: '12:00 - 24:00', start: 24, hours: [12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24] }
      ]
    }
  },
  computed: {
    rangeText() {
      return this.formatRanges().join('、')
    }
  },
  mounted() {
    window.addEventListener('mouseup', this.handleMouseUp)
  },
  beforeDestroy() {
    window.removeEventListener('mouseup', this.handleMouseUp)
  },
  methods: {
    emitSelected() {
      this.$emit('update-selected', this.selected.slice())
    },
    padTime(num) {
      return num < 10 ? '0' + num : String(num)
    },
    indexToTime(index) {
      const hour = Math.floor(index / 2)
      const minute = index % 2 === 0 ? '00' : '30'
      if (hour >= 24) return '24:00'
      return this.padTime(hour) + ':' + minute
    },
    formatRanges() {
      const ranges = []
      let start = null
      for (let i = 0; i <= this.selected.length; i++) {
        const on = i < this.selected.length && this.selected[i]
        if (on && start === null) start = i
        if (start !== null && !on) {
          ranges.push(this.indexToTime(start) + '-' + this.indexToTime(i))
          start = null
        }
      }
      return ranges
    },
    getCellClass(index) {
      let inDragRange = false
      if (this.isMouseDown && this.dragStart !== null && this.dragEnd !== null) {
        const min = Math.min(this.dragStart, this.dragEnd)
        const max = Math.max(this.dragStart, this.dragEnd)
        inDragRange = index >= min && index <= max
      }
      return {
        selected: this.selected[index],
        'drag-highlight': inDragRange
      }
    },
    handleMouseDown(index) {
      this.isMouseDown = true
      this.dragStart = index
      this.dragEnd = index
    },
    handleMouseEnter(index) {
      if (this.isMouseDown) {
        this.dragEnd = index
      }
    },
    handleMouseUp() {
      if (!this.isMouseDown || this.dragStart === null || this.dragEnd === null) return
      const min = Math.min(this.dragStart, this.dragEnd)
      const max = Math.max(this.dragStart, this.dragEnd)
      const nextState = !this.selected[this.dragStart]
      for (let i = min; i <= max; i++) {
        this.$set(this.selected, i, nextState)
      }
      this.emitSelected()
      this.isMouseDown = false
      this.dragStart = null
      this.dragEnd = null
    },
    clearAll() {
      this.selected = Array.from({ length: 48 }, () => false)
      this.emitSelected()
    }
  }
}
</script>

<style lang="less" scoped>
.daily-time {
  width: 100%;
}

.daily-time__legend {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  color: #606266;
  font-size: 12px;
}

.daily-time__legend-item {
  display: flex;
  align-items: center;
  margin-right: 16px;
}

.daily-time__bar {
  display: inline-block;
  width: 20px;
  height: 8px;
  margin-right: 6px;
  background: #ececec;
  border-radius: 1px;

  &.is-selected {
    background: #409eff;
  }
}

.daily-time__axis {
  display: flex;
  background: #f7f8fa;
  border-radius: 4px;
  overflow: hidden;
}

.daily-time__half {
  flex: 1;
  min-width: 0;
  padding: 8px 8px 10px;
}

.daily-time__range {
  margin-bottom: 4px;
  color: #303133;
  font-size: 12px;
  text-align: center;
}

.daily-time__hours {
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
  color: #909399;
  font-size: 12px;
  line-height: 18px;
}

.daily-time__cells {
  display: flex;
  height: 28px;
  overflow: hidden;
  background: #ececec;
}

.daily-time__cell {
  flex: 1;
  height: 100%;
  background: #ececec;
  border-right: 1px solid #fff;
  cursor: pointer;

  &:nth-child(2n) {
    background: #e4e4e4;
  }

  &.selected {
    background: #409eff;
  }

  &.drag-highlight {
    background: rgba(64, 158, 255, 0.35);
  }
}

.daily-time__footer {
  margin-top: 10px;
  font-size: 13px;
  color: #606266;
}

.daily-time__footer-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.daily-time__clear {
  color: #409eff;
  cursor: pointer;
}

.daily-time__ranges {
  margin-top: 4px;
  line-height: 20px;
  word-break: break-all;
}
</style>
